import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getInvoiceVaultPath = () => urlHelper('/invoice-vault');
